/* Peppo cart drawer: bonus stacking + value stack (Hormozi-style) rendered inside Dawn's native drawer.
   Every switch adds or removes the real cart line; Dawn re-renders the drawer. */
(() => {
  const source = document.getElementById('dm-cart-design-config');
  if (!source || !window.DMCartPlan) return;
  const config = JSON.parse(source.textContent);
  const decode = value => String(value ?? '').replace(/&#39;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
  const copy = Object.fromEntries(Object.entries(typeof config.copy === 'object' ? config.copy : {}).map(([k, v]) => [k, decode(v)]));
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency: config.currency || 'USD', maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
  const allIds = new Set(config.products.filter(p => p.id).map(p => p.id));
  const mainIds = new Set(Object.values(config.main));
  const bonusId = Number(config.bonus?.id) || 0;
  const root = () => window.Shopify?.routes?.root || '/';
  const ICON_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="12" rx="2" fill="currentColor" fill-opacity=".12"/><path d="M3 13h18M12 9v12M12 9c-2 0-4.5-1-4.5-3S10 3 12 6c2-3 4.5-2 4.5 0S14 9 12 9z"/></svg>';
  const ICON_UPDATE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v5h-5"/><path d="M12 8v4l2.5 1.5"/></svg>';
  let scheduled = false, busy = false, error = '', cartCache = null;
  const drawer = () => document.querySelector('cart-drawer');
  const rows = el => [...el.querySelectorAll('tr.cart-item[data-variant-id]')];
  const rowId = row => Number(row.dataset.variantId);
  const ownsCart = el => rows(el).some(row => mainIds.has(rowId(row)));
  window.DMCartDesign = {ownsCart};
  function preferred() { try { return sessionStorage.getItem('dm-cart-family-v13'); } catch (_) { return null; } }
  const itemsFromRows = el => rows(el).map(row => ({variant_id: rowId(row), key: row.dataset.lineKey, quantity: Number(row.querySelector('input[name="updates[]"]')?.value || 1)}));

  function switchHtml(product) {
    return `<button class="dm-cart-switch" type="button" role="switch" aria-checked="${product.selected}" aria-label="${escape(product.title)}" data-dm-cart-choice="${product.id}"${busy ? ' disabled' : ''}><span aria-hidden="true"></span></button>`;
  }
  function renderRow(product) {
    const comparison = product.compare > product.cents ? `<s>${money(product.compare)}</s>` : '';
    return `<div class="dm-cart-choice"><img src="${escape(product.image)}" width="56" height="56" alt="" loading="lazy"><div class="dm-cart-choice__copy"><strong>${escape(product.title)}${product.quantity > 1 ? ` <small>×${product.quantity}</small>` : ''}</strong><span class="dm-cart-choice__price">${comparison}<b>${money(product.cents)}</b></span></div>${switchHtml(product)}</div>`;
  }
  function renderBonus(image, title, note, compare, isSvg) {
    return `<div class="dm-cart-bonus">${isSvg ? `<i class="dm-cart-bonus__icon">${image}</i>` : `<img src="${escape(image)}" width="48" height="48" alt="" loading="lazy">`}<div><strong>${escape(title)}</strong><small>${escape(note)}</small></div><span class="dm-cart-bonus__val">${compare ? `<s>${money(compare)}</s>` : ''}<b>${escape(copy.free || 'FREE')}</b></span></div>`;
  }
  function renderLifetime(product) {
    return `<div class="dm-cart-choice dm-cart-choice--lifetime"><i class="dm-cart-lifetime__icon">${ICON_UPDATE}</i><div class="dm-cart-choice__copy"><strong>${escape(copy.lifetime || 'Lifetime updates')} <em>${escape(copy.lifetime_tag || '')}</em></strong><span class="dm-cart-choice__note">${escape(copy.lifetime_note || '')}</span><span class="dm-cart-choice__price">${product.compare > product.cents ? `<s>${money(product.compare)}</s>` : ''}<b>${money(product.cents)}</b></span></div>${switchHtml(product)}</div>`;
  }
  function updateHtml(el, html) {
    if (el._dmHtml === html) return;
    const activeId = el.contains(document.activeElement) ? document.activeElement.dataset.dmCartChoice : null;
    el.innerHTML = html; el._dmHtml = html;
    if (activeId) el.querySelector(`[data-dm-cart-choice="${activeId}"]`)?.focus({preventScroll: true});
  }
  function enhance() {
    scheduled = false;
    const el = drawer();
    if (!el) return;
    const owns = ownsCart(el);
    el.classList.toggle('dm-cart-v13', owns);
    const items = el.querySelector('cart-drawer-items');
    const footer = el.querySelector('.drawer__footer');
    if (!owns || !items || !footer) {
      el.querySelectorAll('.dm-cart-choices,.dm-cart-lifetime,.dm-cart-status,.dm-cart-value').forEach(n => n.remove());
      rows(el).forEach(row => row.classList.remove('dm-cart-source-hidden', 'dm-cart-main'));
      return;
    }
    const cartItems = cartCache?.items || itemsFromRows(el);
    const model = window.DMCartPlan.plan(config, cartItems, preferred());
    if (!model) return;
    try { sessionStorage.setItem('dm-cart-family-v13', model.active); } catch (_) {}
    rows(el).forEach(row => {
      const id = rowId(row);
      row.classList.toggle('dm-cart-source-hidden', allIds.has(id) || id === bonusId);
      row.classList.toggle('dm-cart-main', mainIds.has(id));
    });
    const present = new Set(cartItems.map(i => Number(i.variant_id)));
    const hasBonus = bonusId && present.has(bonusId);
    const gifts = [...model.core, ...model.other].filter(p => p.cents === 0 && p.selected);
    const core = model.core.filter(p => p.cents !== 0);
    const other = model.other.filter(p => p.cents !== 0);
    rows(el).forEach(row => {
      if (!row.classList.contains('dm-cart-main')) return;
      const fam = Object.keys(config.main).find(k => config.main[k] === rowId(row));
      const worth = Number(config.mainCompare?.[fam] || 0);
      let tag = row.querySelector('.dm-cart-main__tag');
      if (!tag) { tag = document.createElement('span'); tag.className = 'dm-cart-main__tag'; row.querySelector('.cart-item__details')?.append(tag); }
      const text = worth ? `${copy.free || 'FREE'} · worth ${money(worth)}` : (copy.free || 'FREE');
      if (tag.textContent !== text) tag.textContent = text;
    });
    // ---- value stack
    let value = 0;
    for (const [fam, id] of Object.entries(config.main)) if (present.has(id)) value += Number(config.mainCompare?.[fam] || 0);
    // App bonus + gifts are already counted inside the main kit's compare-at value.
    [...core, ...other, ...model.extra].forEach(p => { if (p.selected) value += (p.compare || p.cents) * (p.quantity || 1); });
    if (model.lifetime?.selected) value += model.lifetime.compare || model.lifetime.cents;
    const today = Number(cartCache?.total_price);
    // ---- panel
    let panel = items.querySelector('.dm-cart-choices');
    if (!panel) { panel = document.createElement('div'); panel.className = 'dm-cart-choices'; items.querySelector('#CartDrawer-CartItems')?.append(panel); }
    let html = '';
    if (hasBonus || gifts.length) {
      const worth = (hasBonus ? 899 : 0) + gifts.reduce((s, p) => s + (p.compare || 0), 0);
      html += `<section class="dm-cart-bonuses"><h3><i>${ICON_GIFT}</i>${escape(copy.bonuses_title || 'Free bonuses included')}${worth ? ` <em>worth ${money(worth)}</em>` : ''}</h3>`;
      if (hasBonus) html += renderBonus(config.bonus.image, copy.bonus_title, copy.bonus_note, 899, false);
      gifts.forEach(p => html += renderBonus(p.image, p.title, copy.gift_note, p.compare, false));
      html += `</section>`;
    }
    const title = model.active === 'phonics' ? copy.phonics_title : copy.life_title;
    html += `<div class="dm-cart-strip"><strong>${escape(title)}</strong><span>${escape(copy.optional)}</span></div><div class="dm-cart-core">${core.map(p => renderRow(p)).join('')}</div>`;
    if (other.length) html += `<section class="dm-cart-more"><h3>${escape(copy.other_title)}</h3><p>${escape(copy.other_note)}</p>${other.map(p => renderRow(p)).join('')}</section>`;
    if (model.extra.length) html += `<section class="dm-cart-more dm-cart-more--optional"><h3>${escape(copy.extra_title)}</h3><p>${escape(copy.extra_note)}</p>${model.extra.map(p => renderRow(p)).join('')}</section>`;
    updateHtml(panel, html);
    // ---- footer: lifetime pin + value line
    let pin = footer.querySelector('.dm-cart-lifetime');
    if (!pin) { pin = document.createElement('div'); pin.className = 'dm-cart-lifetime'; const ctas = footer.querySelector('.cart__ctas'); if (ctas) ctas.prepend(pin); else footer.prepend(pin); }
    pin.classList.toggle('is-on', !!model.lifetime?.selected);
    updateHtml(pin, model.lifetime ? renderLifetime(model.lifetime) : '');
    let val = footer.querySelector('.dm-cart-value');
    if (!val) { val = document.createElement('div'); val.className = 'dm-cart-value'; const totals = footer.querySelector('.totals'); (totals?.parentElement || footer).insertBefore(val, totals || null); }
    if (Number.isFinite(today)) updateHtml(val, `<span>${escape(copy.value_label || 'Total value')} <s>${money(value)}</s></span><b>${escape(copy.today_label || 'You pay today')} ${money(today)}</b>`);
    let status = footer.querySelector('.dm-cart-status');
    if (!status) { status = document.createElement('p'); status.className = 'dm-cart-status'; status.setAttribute('role', 'status'); footer.prepend(status); }
    if (status.textContent !== error) status.textContent = error;
    el.setAttribute('aria-busy', String(busy));
    const checkout = el.querySelector('#CartDrawer-Checkout');
    if (checkout) {
      if (busy && !checkout.disabled) { checkout.disabled = true; checkout.dataset.dmCartLocked = 'true'; }
      else if (!busy && checkout.dataset.dmCartLocked) { checkout.disabled = false; delete checkout.dataset.dmCartLocked; }
      if (Number.isFinite(today)) {
        const label = today === 0 ? (copy.claim || 'Claim my free bundle') : `${copy.checkout || 'Checkout'} · ${money(today)}`;
        if (checkout.textContent.trim() !== label) checkout.textContent = label;
      }
    }
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(enhance); } }
  async function request(url, options = {}) {
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(url, {...options, signal: controller.signal, headers: {Accept: 'application/json', ...options.headers}});
      if (!response.ok) throw new Error(String(response.status));
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  async function refreshCart() { cartCache = await request(root() + 'cart.js', {cache: 'no-store'}); return cartCache; }
  function markRemoved(id) {
    try {
      if (config.core.phonics.includes(id) || config.extra.phonics.includes(id)) { const values = new Set(JSON.parse(sessionStorage.getItem('dm-phonics-choice-v1') || '[]')); values.add(id); sessionStorage.setItem('dm-phonics-choice-v1', JSON.stringify([...values])); }
      if (config.core.life.includes(id) || config.extra.life.includes(id)) sessionStorage.setItem('dm-auto-bundle-v13', 'edited');
    } catch (_) {}
  }
  async function rerender() {
    const items = document.querySelector('cart-drawer-items');
    if (typeof items?.onCartUpdate === 'function') { try { await items.onCartUpdate(); } catch (_) {} }
    document.getElementById('cart-icon-bubble') && syncBubble();
  }
  async function syncBubble() {
    try {
      const html = await (await fetch(`${root()}?section_id=cart-icon-bubble`)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (fresh && target) target.innerHTML = fresh.innerHTML;
    } catch (_) {}
  }
  async function toggle(id) {
    if (busy || !allIds.has(id)) return;
    busy = true; error = ''; schedule();
    try {
      const before = await refreshCart();
      const updates = window.DMCartPlan.removalUpdates(before.items, id);
      if (Object.keys(updates).length) { await request(root() + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({updates})}); markRemoved(id); }
      else { await request(root() + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id, quantity: 1, properties: {_dm_bundle_addon: 'true'}}]})}); }
      window.PeppoBundle?.invalidate?.();
      await refreshCart();
      await rerender();
    } catch (_) { error = copy.error || 'Could not update your cart. Please try again.'; }
    finally { busy = false; schedule(); }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-dm-cart-choice]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    toggle(Number(button.dataset.dmCartChoice));
  }, true);
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('cart-drawer-items, .drawer__footer, tr.cart-item') || n.querySelector?.('tr.cart-item'))))) refreshCart().then(schedule).catch(schedule);
    else schedule();
  }).observe(document.documentElement, {childList: true, subtree: true});
  refreshCart().then(schedule).catch(schedule);
})();
